/**
 * Round Float Number
 * @param {Number}  number float number
 * @param {Number}  precision numeber decimals, default 4
 * @return {Number}  Float number with decimals to 4 digits
 */
export function roundFloat(number, precision=4) {
    return Number(Number.parseFloat(number).toFixed(precision));
}